// extracted by mini-css-extract-plugin
export var bmBurgerButton = "hamburger-module--bm-burger-button--1ofzH";
export var buttonDonate = "hamburger-module--buttonDonate--yEuBs";
export var buttonGet = "hamburger-module--buttonGet--bakxl";
export var buttonGetMobile = "hamburger-module--buttonGetMobile--6HGb8";
export var logoInline = "hamburger-module--logoInline--vgf-+";